import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: "#FCFCFC",
      width:"90%"
    }
  }));

const AutoCompleteField = ({state, data, setState, params, listKey, edit, setEditData, editData, orjinalData}) => {
    const classes = useStyles();
    let datas = state[params]?.map(x => x.id) ;


    const handleChange = (value,reason) => {
      if(edit?.type === "edit"){
          if(reason === "select-option"){
            setEditData({createDatas:{...editData.createDatas , [params]:value}, deleteDatas:{...editData.deleteDatas}})
          }else if(reason === "remove-option"){
            if(value.length === 0){ 
              console.log("burada",orjinalData);
              setEditData({createDatas:{...editData.createDatas}, deleteDatas:{...editData.deleteDatas, [params]:orjinalData[params]}})
            }else{
              setEditData({createDatas:{...editData.createDatas}, deleteDatas:{...editData.deleteDatas, [params]:value}})
            }
          }else if(reason === "clear" || value.length === 0){
            setEditData({createDatas:{...editData.createDatas}, deleteDatas:{...editData.deleteDatas, [params]:orjinalData[params]}})
          }
      }
      const filter = state[params]?.map((action) => action.id);
      if(!(filter.includes(value[value.length - 1]?.id)) || reason === "remove-option"){
        setState({ ...state, [params]: value})
      }
    }

    return (
        <div className={classes.root}>
        <Autocomplete
              multiple  
              id="tags-outlined1"
              value={state[params]}
              options={data.filter(x => !datas?.includes(x.id))}
              getOptionLabel={(option) => {
                //filter value
                return `${option[listKey]}`;
              }}
              size="small"
              onChange={(event, value, reason) => handleChange(value,reason)}
              filterSelectedOptions
              renderInput={(param) => (
                <TextField {...param} variant="outlined" />
              )}
            />
        </div>
    )
}


export default AutoCompleteField;